/**
 * CANVY PC診断 → 商品ページの構成選択（2026-09-30）
 *
 * 診断の「この構成を見る」は、商品ページを ?cv_grade=4&cv_ram=32&cv_ssd=1000 のように開く。
 * このスクリプトは、その指定どおりに商品オプション（Globo）のモデル・メモリ・メインストレージを選ぶ。
 * 読み込み：layout/theme.liquid（商品ページだけ）。指定が無いページでは何もしない。
 * グレードの CPU / GPU は sections/canvy-pc-concierge.liquid の grades と合わせること。
 */
(function () {
  var params = new URLSearchParams(window.location.search);
  var grade = Number(params.get('cv_grade'));
  if (!grade) return;
  var ram = Number(params.get('cv_ram')) || 16;
  var ssd = Number(params.get('cv_ssd')) || 500;

  var GRADES = {
    1: { cpu: 'Ryzen 5 5500', gpu: 'RTX 3050', ramType: 'DDR4' },
    2: { cpu: 'Ryzen 5 5500', gpu: 'RTX 5050', ramType: 'DDR4' },
    3: { cpu: 'Ryzen 7 5700X', gpu: 'RTX 5060', ramType: 'DDR4' },
    4: { cpu: 'Ryzen 7 5700X', gpu: 'RTX 5070', ramType: 'DDR4' },
    5: { cpu: 'Ryzen 7 9800X3D', gpu: 'RTX 5070', ramType: 'DDR5' },
    6: { cpu: 'Ryzen 9 9950X3D', gpu: 'RTX 5080', ramType: 'DDR5' }
  };
  var g = GRADES[grade];
  if (!g) return;
  var ramValue = g.ramType + ' ' + ram + 'GB';
  var ssdLabel = ssd >= 1000 ? (ssd / 1000) + 'TB' : ssd + 'GB';

  var text = function (value) {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  };
  var radios = function () {
    return Array.prototype.slice.call(document.querySelectorAll('.gpo-container input[type="radio"]'));
  };
  // 見つかれば選び（すでに選ばれていれば何もしない）、見つかったかどうかを返す
  var pick = function (match) {
    var input = radios().find(function (item) { return match(text(item.value)); });
    if (!input) return false;
    if (!input.checked) input.click();
    return true;
  };

  var doneGrade = false;
  var doneRam = false;
  var doneSsd = false;
  var attempts = 0;
  var run = function () {
    attempts += 1;
    if (!doneGrade) {
      doneGrade = pick(function (t) { return t.indexOf(g.cpu) !== -1 && t.indexOf(g.gpu) !== -1; });
    }
    // メモリの選択肢（DDR4 / DDR5）はモデルに合わせて切り替わるので、モデルを選んでから選ぶ
    if (doneGrade && !doneRam) {
      doneRam = pick(function (t) { return t === ramValue; });
    }
    if (doneGrade && !doneSsd) {
      doneSsd = pick(function (t) { return /SSD/i.test(t) && t.slice(-ssdLabel.length) === ssdLabel; });
    }
    if (!(doneGrade && doneRam && doneSsd) && attempts < 60) {
      window.setTimeout(run, 250);
    } else if (!(doneGrade && doneRam && doneSsd)) {
      console.warn('CANVY PC診断: 商品ページで構成を選べませんでした', { grade: grade, ram: ram, ssd: ssd });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
